import "./Advertisement.css";
import adsImage from "../../../assets/images/Picture1.png";
import chart from "../../../assets/images/progress chart.png";
import { useSelector } from "react-redux";
import {
  selectIsAdmin,
  selectAuthenticated,
} from "../../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";

const Advertisement = () => {
  const isAdmin = useSelector(selectIsAdmin);
  console.log("isAdmin", isAdmin);

  const isAuthenticated = useSelector(selectAuthenticated);
  const navigate = useNavigate();

  const handleReklamoClick = () => {
    if (!isAuthenticated) {
      navigate("/login");
    } else if (isAdmin) {
      navigate("/posts");
    } else {
      navigate("/lajmet");
    }
  };

  return (
    <div className="advertisement-section">
      <div className="advertisementTitle">
        <h1>
          RE<span className="yellowText">K</span>LAM
          <span className="yellowText">O</span>
          NI<span className="yellowText"> .</span>
        </h1>
      </div>
      <div className="advertisementImages">
        <span className="yellowText">
          <h4>Shumë shpejt do të mund të reklamoni me ne...</h4>
        </span>
      </div>
    </div>
  );
};

export default Advertisement;
